export default "__VITE_ASSET__3VTS6DnW__"